import {
  MOSCOW_AREA_REGION_ID,
  MOSCOW_REGION_ID,
  MOSCOW_WITH_AREA_REGION_ID,
  ST_PETERSBURG_AREA_REGION_ID,
  ST_PETERSBURG_REGION_ID,
  ST_PETERSBURG_WITH_AREA_REGION_ID,
} from '../geoSwitcher';

export const VILLAGES_LINK = '/kottedzhnye-poselki/';
export const AVAILABLE_IN_REGIONS = [
  MOSCOW_REGION_ID,
  MOSCOW_AREA_REGION_ID,
  MOSCOW_WITH_AREA_REGION_ID,
  ST_PETERSBURG_REGION_ID,
  ST_PETERSBURG_AREA_REGION_ID,
  ST_PETERSBURG_WITH_AREA_REGION_ID,
];
export const MOSCOW_IDS = [MOSCOW_REGION_ID, MOSCOW_AREA_REGION_ID, MOSCOW_WITH_AREA_REGION_ID];
